import { render, staticRenderFns } from "./StartInfosList.vue?vue&type=template&id=3956141e&"
import script from "./StartInfosList.vue?vue&type=script&lang=js&"
export * from "./StartInfosList.vue?vue&type=script&lang=js&"
import style0 from "./StartInfosList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports